
import React from 'react';
import { AccountPanel } from './AccountPanel';
import { SettingsPanel } from './SettingsPanel';

export const DashboardPage: React.FC = () => {

    return (
        <div className="page">
            <AccountPanel />
            
            <SettingsPanel />
        </div>
    );
}